import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FacultyTrackingDashbaordRoutingModule } from './faculty-tracking-dashbaord-routing.module';
import { FacultyLinkComponent } from './faculty-link/faculty-link.component';
import { OutingApprovalModule } from '../outing-approval/outing-approval.module';
import { FacultyTrackingNewDashboardComponent } from './faculty-tracking-new-dashboard/faculty-tracking-new-dashboard.component';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { FacultytrackingnewdialogComponent } from './facultytrackingnewdialog/facultytrackingnewdialog.component';
import { NewperiodImageDialogComponent } from './newperiod-image-dialog/newperiod-image-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { TimetableCellRenderer } from './faculty-tracking-new-dashboard/timetable-cell-renderer/timetable-cell-renderer.component';
import { CampusGoogleMapComponent } from './campus-google-map/campus-google-map.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { DialogFilterComponent } from './dialog-filter/dialog-filter.component';


export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  }
};



@NgModule({
  declarations: [
    FacultyLinkComponent,
    FacultyTrackingNewDashboardComponent,
    FacultytrackingnewdialogComponent,
    NewperiodImageDialogComponent,
    TimetableCellRenderer,
    CampusGoogleMapComponent,
    DialogFilterComponent

  ],
  imports: [
    CommonModule,
    FacultyTrackingDashbaordRoutingModule,
    OutingApprovalModule,
    AgGridModule,
    SharedModule,
    MatFormFieldModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatNativeDateModule,
    MatOptionModule,
    MatSelectModule,
    NgxSpinnerModule,
    MatAutocompleteModule,
    MatIconModule,
    AgGridAngular,
    GoogleMapsModule 
  ],

  // providers: [NgDialogAnimationService]
  providers: [NgDialogAnimationService,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },   // DD/MM/YYYY
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ]
})
export class FacultyTrackingDashbaordModule { }
